import useIndicesConfiguration from "hooks/useIndicesConfiguration";
const useTimeSizeOptimizingFixedLeeway = () => {
  const { rotationStrategiesContext } = useIndicesConfiguration();
  return rotationStrategiesContext == null ? void 0 : rotationStrategiesContext.time_size_optimizing_retention_fixed_leeway;
};
export default useTimeSizeOptimizingFixedLeeway;
